<template>
  <el-dialog
    class="radish-dia"
    title="是否需要将人选加入项目"
    top="70px"
    width="285px"
    :modal="false"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div v-if="dialogVisible">
      <el-select v-if="projects.length > 0" v-model="pid" filterable size="mini" placeholder="选择项目">
        <el-option v-for="pro in projects" :key="pro.value" :label="pro.label" :value="pro.value"></el-option>
      </el-select>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="handleConfirm">不加项目直接上传</el-button>
      <el-button size="mini" type="primary" @click="handleConfirm">确定加入项目</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    onConfirm: {
      type: Function,
      default: function() {},
    },
  },
  data: function() {
    return {
      dialogVisible: false,
      projects: [],
      pid: '',
    }
  },
  methods: {
    show: async function() {
      this.pid = ''
      await app.getProjects()
      const proData = app.projects
      if (proData && proData.length) {
        this.projects = proData.map(item => {
          const label = `${item['项目名称']}(${item['客户公司']})`
          return { label: label, value: item._id }
        })
      }
      this.dialogVisible = true
    },
    handleConfirm: async function() {
      this.dialogVisible = false
      this.onConfirm(this.pid)
    },
  },
}
</script>
